import { defineStore } from 'pinia';
import { actions, state } from '@/stores/methods';


export const useMessagesStore = defineStore('message', {
  state: state,
  actions: actions,
  getters: {
    getConversationMessages: (state) => {
      return (channelIds) => {
        return state.collection.filter(m => channelIds.indexOf(m.customer_channel_id) !== -1);
      };
    },
  },
});
